 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-02def60a":"00e6aef5","chunk-0483af4f":"4464e6dc","chunk-1d168d00":"5a59cb31","chunk-2d0e13c0":"f065fa57","chunk-2efd69bc":"c803bd40","chunk-01da2fc5":"a8178973","chunk-2275851d":"f5d15633","chunk-2d0d7a57":"604af3a2","chunk-2d207762":"e1ee1de3","chunk-40ac0e06":"5d7be066","chunk-4b316368":"aa9f9cfb","chunk-194e4c48":"d4a4ac5f","chunk-6d189f79":"a28cc4e9","chunk-4c598a34":"6dcc922a","chunk-53138004":"ee551b34","chunk-7378afc2":"03581f72","chunk-014d8ba8":"84ed71f8","chunk-0eca4fb1":"712e4b22","chunk-6c783296":"1ed89717","chunk-71ef41fa":"37f8bfad","chunk-3018e7ad":"269510b7","chunk-9976ac60":"11db00e7","chunk-406bd321":"b04e2f4b","chunk-3f6889b2":"1e6533c5","chunk-f42db444":"a1934621","chunk-01873e7e":"8bb7d6c8","chunk-1db285cf":"836e99b6","chunk-42d36b0d":"773c31fc","chunk-502dfcbc":"6c799f15","chunk-2d0c8636":"2140f11d","chunk-3975ed64":"4e580f89","chunk-5baaa26d":"6be494e2","chunk-743e4b25":"47398025","chunk-74524b79":"2bcfb7ae","chunk-746154ec":"b2d98dcb","chunk-7498e9ec":"ba910fca","chunk-74a82e1a":"a73a41d7","chunk-74b6aca8":"97ec2f39","chunk-76b2a6b2":"5724bb22","chunk-76f08193":"a73e0719","chunk-771a7e38":"5cf79c9c","chunk-c45dfeec":"2a4d2772","chunk-c52bd230":"640c12ee","chunk-dacac238":"72d031db"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-1d168d00":1,"chunk-01da2fc5":1,"chunk-2275851d":1,"chunk-40ac0e06":1,"chunk-4b316368":1,"chunk-194e4c48":1,"chunk-6d189f79":1,"chunk-4c598a34":1,"chunk-53138004":1,"chunk-7378afc2":1,"chunk-014d8ba8":1,"chunk-0eca4fb1":1,"chunk-6c783296":1,"chunk-71ef41fa":1,"chunk-3018e7ad":1,"chunk-9976ac60":1,"chunk-406bd321":1,"chunk-01873e7e":1,"chunk-1db285cf":1,"chunk-42d36b0d":1,"chunk-502dfcbc":1,"chunk-3975ed64":1,"chunk-5baaa26d":1,"chunk-743e4b25":1,"chunk-74524b79":1,"chunk-746154ec":1,"chunk-7498e9ec":1,"chunk-74a82e1a":1,"chunk-74b6aca8":1,"chunk-76f08193":1,"chunk-771a7e38":1,"chunk-c45dfeec":1,"chunk-c52bd230":1,"chunk-dacac238":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-02def60a":"31d6cfe0","chunk-0483af4f":"31d6cfe0","chunk-1d168d00":"084d66fa","chunk-2d0e13c0":"31d6cfe0","chunk-2efd69bc":"31d6cfe0","chunk-01da2fc5":"6654b603","chunk-2275851d":"385ad187","chunk-2d0d7a57":"31d6cfe0","chunk-2d207762":"31d6cfe0","chunk-40ac0e06":"290734d4","chunk-4b316368":"84f98409","chunk-194e4c48":"bb68e670","chunk-6d189f79":"e8cc599e","chunk-4c598a34":"07f478e6","chunk-53138004":"9be70aea","chunk-7378afc2":"aa316f16","chunk-014d8ba8":"babd4104","chunk-0eca4fb1":"397bd3e6","chunk-6c783296":"fc377af6","chunk-71ef41fa":"b27cfab6","chunk-3018e7ad":"aed768fd","chunk-9976ac60":"c258497c","chunk-406bd321":"b7c5e579","chunk-3f6889b2":"31d6cfe0","chunk-f42db444":"31d6cfe0","chunk-01873e7e":"6f2e3a65","chunk-1db285cf":"6f2e3a65","chunk-42d36b0d":"3b7bd6c7","chunk-502dfcbc":"0b82f8c5","chunk-2d0c8636":"31d6cfe0","chunk-3975ed64":"7391b5d4","chunk-5baaa26d":"6d3eac86","chunk-743e4b25":"b7e4a7f0","chunk-74524b79":"02574d02","chunk-746154ec":"8ce05047","chunk-7498e9ec":"163ac366","chunk-74a82e1a":"5c34488f","chunk-74b6aca8":"12720cd8","chunk-76b2a6b2":"31d6cfe0","chunk-76f08193":"e7843f49","chunk-771a7e38":"9eff7aa8","chunk-c45dfeec":"eb4f77b9","chunk-c52bd230":"9d5d2f9a","chunk-dacac238":"cb445c1b"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/segel/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
